import { ContentType } from '#types/generated/graphql-types';

type State = {
  contentType?: ContentType;
  visible: boolean;
  canShowPlayer: boolean;
  mediaIri?: string;
};

export const state: State = {
  visible: false,
  canShowPlayer: false,
};
